const COURSE_LIST = {
    "语文": {
        courseName: "语文",
        courseIcon: require("@/assets/image/curriculum/language.png"),
        bgColor:'#FF6701',
    },
    "数学": {
        courseName: "数学",
        courseIcon: require("@/assets/image/curriculum/math.png"),
        bgColor:'#51D76A',
    },
    "英语": {
        courseName: "英语",
        courseIcon: require("@/assets/image/curriculum/english.png"),
        bgColor:'#FC3E39',
    },
    "思想品德": {
        courseName: "思想品德",
        courseIcon: require("@/assets/image/curriculum/Ideological.png"),
        bgColor:'#f9ae3d',
    },
    "道德与法治": {
        courseName: "道德与法治",
        courseIcon: require("@/assets/image/curriculum/morality.png"),
        bgColor:'#f56c6c',
    },
    "政治": {
        courseName: "政治",
        courseIcon: require("@/assets/image/curriculum/politics.png"),
        bgColor:'#7D92FE',
    },
    "历史": {
        courseName: "历史",
        courseIcon: require("@/assets/image/curriculum/history.png"),
        bgColor:'#FD9527',
    },
    "地理": {
        courseName: "地理",
        courseIcon: require("@/assets/image/curriculum/geography.png"),
        bgColor:'#28D3B1',
    },
    "生物": {
        courseName: "生物",
        courseIcon: require("@/assets/image/curriculum/biology.png"),
        bgColor:'#AA55FF',
    },
    "化学": {
        courseName: "化学",
        courseIcon: require("@/assets/image/curriculum/chemistry.png"),
        bgColor:'#56C4FE',
    },
    "物理": {
        courseName: "物理",
        courseIcon: require("@/assets/image/curriculum/physics.png"),
        bgColor:'#1680FA',
    },
    "体育": {
        courseName: "体育",
        courseIcon: require("@/assets/image/curriculum/sports.png"),
        bgColor:'#02a2f8',
    },
    "音乐": {
        courseName: "音乐",
        courseIcon: require("@/assets/image/curriculum/music.png"),
        bgColor:'#00e74e',
    },
    "美术": {
        courseName: "美术",
        courseIcon: require("@/assets/image/curriculum/art.png"),
        bgColor:'#cfe3d6',
    },
    "信息技术": {
        courseName: "信息技术",
        courseIcon: require("@/assets/image/curriculum/information.png"),
        bgColor:'#3c9cff',
    },
    "其他": {
        courseName: "其他",
        courseIcon: require("@/assets/image/curriculum/others.png"),
        bgColor:'#e45656',
    },
}

export default COURSE_LIST